import Vue from "vue";

/**
 * Class Action Service
 */
export default class ActionService extends Vue {
  private customActions = {
      indexStatus: { method: 'GET', url: 'lead/action/status/{statusName}{/platformId}' },
      showActions: { method: 'GET', url: 'auth/action/platform{/id_platform}' },
      show: { method: 'GET', url: 'auth/action/platform' }
  };
  private resource: any = this.$resource(
    "lead/action{/id}",
    {},
    this.customActions
  );

  // GET all
  public index() {
    return this.resource.get().then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }

  // GET all with statusName
  public indexStatus(statusName: string, platformId?: number) {
    let params = {statusName};
    if (platformId)
      params['platformId'] = platformId;
    return this.resource.indexStatus(params);
  }

  // GET one
  public show(id: number) {
    return this.resource.get({ id }).then(
      (response: any) => {
        return response.json();
      },
      (response: any) => {
        return response.json();
      }
    );
  }
    
    // GET action by platform
    public showActions(id_platform: number) {
        return this.resource.showActions({ id_platform }).then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }

    // GET alls
    public showAllAction() {
        return this.resource.show().then(
            (response: any) => {
                return response.json();
            },
            (response: any) => {
                return response.json();
            }
        );
    }
}
